var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 2H7.96874C7.29564 2 6.74999 2.54566 6.74999 3.21875C6.74999 3.89185 7.29564 4.4375 7.96874 4.4375H12.0312C12.7043 4.4375 13.25 3.89185 13.25 3.21875C13.25 2.54566 12.7043 2 12.0312 2Z",
    stroke: "#C2C2C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74999 12.5625H9.53574M6.74999 9.3125H13.25",
    stroke: "#C2C2C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 3.21875C14.5121 3.25679 15.265 3.39756 15.7861 3.91861C16.5 4.63254 16.5 5.78157 16.5 8.07963V13.3745C16.5 15.6727 16.5 16.8217 15.7861 17.5357C15.0721 18.2495 13.9231 18.2495 11.625 18.2495H8.37499C6.0769 18.2495 4.92785 18.2495 4.21393 17.5357C3.50001 16.8217 3.5 15.6727 3.5 13.3746L3.50001 8.07968C3.5 5.78158 3.5 4.63253 4.21393 3.9186C4.73497 3.39756 5.48779 3.25678 6.74992 3.21875",
    stroke: "#C2C2C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIc);
export default __webpack_public_path__ + "static/media/reportIc.1ad37bfef6e6fbc3fc43611f96660bb7.svg";
export { ForwardRef as ReactComponent };